/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import {
  Tooltip,
  Popconfirm,
  Radio,
  Space,
  Button,
  message,
  Select,
} from "antd";
import React, { useState } from "react";

import print_icon from "../../../../assests/images/printIcon.svg";
import editIcon from "../../../../assests/images/edit-logo.svg";

import useCustomNavigate from "../../../../components/customNavigationHook";

// Filters

import "antd/dist/antd.css";

import {
  capitaliseWithHyphen,
  commonSorterForTable,
  normalizeService,
  normalizeString,
  serialNum,
} from "../../../../utils";
// import "./AllBookingTable.scss";
import urls from "../../../../api/urls";
import API from "../../../../api";
// import Filters from "./Filters";

export const column = ({
  MyComponent,
  statusFun,
  handleEyeButton,
  handleEdit,
  pageSize,
  pageNum,
  loading,
  setLoading,
  isDiscounted,
}) => {
  const navigate = useCustomNavigate();
  const { GET_ALL_STAFF, PRINT_RETAIL_INVOICE } = urls;

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const cashPrint = async (id) => {
    // setLoadTable(true);
    let response = await API.Api(
      PRINT_RETAIL_INVOICE + id
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      // setLoadTable(false);
      let data = response?.response?.data?.data;

      data?.invoiceUrl
        ? window.open(data?.invoiceUrl)
        : message.error("Internal server error.");
    } else {
      // setLoadTable(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  let columns = [
    {
      title: "SI",
      width: 60,
      dataIndex: "sl",
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, 1, idx),
    },
    {
      title: (
        <>
          <span>
            Document <br /> Number
          </span>
        </>
      ),
      dataIndex: "documentNo",
      key: "documentNo",
      className: "documentNo",
      fixed: "left",
      width: 115,
      render: (text, record) => {
        return (
          <div>
            <div>
              <a onClick={() => handleEyeButton(record)}>{text}</a>
            </div>
            {record?.childCount > 0 && (
              <div
                style={{
                  color: "#09A70C",
                  display: "inline",
                  padding: "2px 7px",
                  border: "1px solid #09A70C",
                  borderRadius: "10px",
                  background: "#d3ffd3",
                }}
              >
                {"+" + record?.childCount + " Child"}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <>
          <span>
            Receiver <br /> Name
          </span>
        </>
      ),
      dataIndex: ["receiverAddress", "name"],
      key: ["receiverAddress", "name"],
      width: 80,
      render: (text) => {
        return <div>{formatText(capitaliseWithHyphen(text), 15)}</div>;
      },
    },
    {
      title: "Service Type",
      dataIndex: "deliveryPromise",
      key: "serviceType",
      width: 100,
      render: (text) => normalizeService(text) || "N/A",
    },
    {
      title: "Doc Type",
      dataIndex: "shipmentType",
      key: "docType",
      width: 70,
      render: (text) => text || "N/A",
    },
    {
      title: "Travel By",
      dataIndex: "travelBy",
      key: "travelBy",
      width: 60,
      render: (text) => capitaliseWithHyphen(text) || "N/A",
    },
    {
      title: (
        <>
          <span>
            Weight <br /> L * W * H
          </span>
        </>
      ),
      dataIndex: "dwsWeight",
      key: "weight",
      align: "center",
      width: 80,
      render: (text, record) => {
        return (
          <div>
            <div style={{ textAlign: "center" }}>{+text / 1000 || "N/A"}</div>
            {record?.shipmentType?.toUpperCase() !== "DOX" && (
              <div style={{ fontSize: "10px" }}>
                {`${record?.dwsLength || 0} * ${record?.dwsWidth || 0} * ${
                  record?.dwsHeight || 0
                }`}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <>
          <span>
            Freight <br /> Charges
          </span>
        </>
      ),
      dataIndex: ["charges", "subTotal"],
      key: "originalCharges",
      align: "center",
      width: 80,
      render: (text) => text || "N/A",
    },
    {
      title: "SGST",
      dataIndex: ["charges", "sgst"],
      key: "sgst",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: "CGST",
      dataIndex: ["charges", "cgst"],
      key: "cgst",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: "IGST",
      dataIndex: ["charges", "igst"],
      key: "igst",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: "CESS",
      dataIndex: ["charges", "cess"],
      key: "cess",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: (
        <>
          <span>
            Total <br /> Freight
          </span>
        </>
      ),
      dataIndex: ["charges", "amount"],
      key: "freight",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: (
        <>
          <span>
            Packaging <br /> charge
          </span>
        </>
      ),
      dataIndex: ["charges", "packagingCharge"],
      key: "packagingCharge",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
    {
      title: (
        <>
          <span>
            Total <br /> Charges
          </span>
        </>
      ),
      dataIndex: ["charges", "totalCharge"],
      key: "totalCharge",
      align: "center",
      width: 70,
      render: (text) => text || "0.00",
    },
  ];
  if (isDiscounted) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (a, record) => {
        return (
          <Tooltip title={"Print invoice"} placement="left">
            <p
              className="vbooking-icons"
              style={{
                cursor: "pointer",
              }}
            >
              <img
                src={print_icon}
                style={{ width: "22px", height: "20px" }}
                onClick={(e) => {
                  cashPrint(record?.documentNo);
                }}
              />
            </p>
          </Tooltip>
        );
      },
    });
  } else {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (a, record) => {
        let enabled = true;
        return (
          <Tooltip title={enabled ? "Edit" : null} placement="left">
            <p
              className="vbooking-icons"
              style={{
                cursor: enabled ? "pointer" : "not-allowed",
              }}
            >
              <img
                src={editIcon}
                style={{ width: "22px", height: "20px" }}
                onClick={(e) => {
                  if (enabled) {
                    handleEdit(record?.documentNo);
                  } else {
                    e.preventDefault();
                  }
                }}
              />
            </p>
          </Tooltip>
        );
      },
    });
  }

  return columns;
};
